// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"business-resource-logos_downloadButton__tyvrD"};